import { action } from 'typesafe-actions';
import { CoreActionTypes } from './types';

export const updateLegalAdviseDisclaimer = (value: boolean) =>
  action(CoreActionTypes.UPDATE_LEGAL_ADVISE_DISCLAIMER, value);
export const updateInfoProcessing = (value: boolean, config: any) =>
  action(CoreActionTypes.UPDATE_INFO_PROCESSING, { value, config });
